module.exports = ensureHeader
function ensureHeader (headers, key, value) {
  var lower = key.toLowerCase()
  if (!headers[key] && !headers[lower]) {
    headers[key] = value
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/xhr-request/lib/ensure-header.js
// module id = Yg7g
// module chunks = 0